export const CONTEST_LIST_FETCH = 'contestList/FETCH';
export const CONTEST_LIST_DATA = 'contestList/DATA';
export const CONTEST_LIST_ERROR = 'contestList/ERROR';


